module.exports = __webpack_public_path__ + "img/Group 688four.34c9abf1.png";